import { render, staticRenderFns } from "./ModalCreateOrganizationApiContent.vue?vue&type=template&id=44a28c8c&scoped=true"
import script from "./ModalCreateOrganizationApiContent.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrganizationApiContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a28c8c",
  null
  
)

export default component.exports